import { Vertical } from '@weave/schema-gen-ts/dist/shared/vertical/vertical.pb';
import { APPOINTMENT_TYPE_DENTAL, APPOINTMENT_TYPE_OPTO, APPOINTMENT_TYPE_VET } from '../constant';
import { AppointmentTypeEnum } from '../types';

export const verticalMapping: Partial<Record<Vertical, readonly AppointmentTypeEnum[]>> = {
  [Vertical.DENTAL]: APPOINTMENT_TYPE_DENTAL,
  [Vertical.VET]: APPOINTMENT_TYPE_VET,
  [Vertical.OPTOMETRY]: APPOINTMENT_TYPE_OPTO,
};
